/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const AddUserRequest = zod.object({
  email: zod.string(),
  name: zod.string(),
  role: zod.enum(['admin', 'user']),
})

export type AddUserRequest = zod.input<typeof AddUserRequest>
export type AddUserRequestOutput = zod.output<typeof AddUserRequest>
